const CUSTODIAN_TERM = "Issuer";
const CUSTODIAN_TERM_PLURAL = "Issuers";
const CUSTODIAN_TERM_FULL = "Asset issuer";
const CUSTODIAN_TERM_FULL_PLURAL = "Asset issuers";

const custodian = { CUSTODIAN_TERM, CUSTODIAN_TERM_PLURAL, CUSTODIAN_TERM_FULL, CUSTODIAN_TERM_FULL_PLURAL };

const COLLATERAL_TERM = "Collateral";
const COLLATERAL_DEPOSITS_TERM = "Collateral deposits";
const BORROW_TERM = "Borrow";
const BORROW_TERM_GERUND = "Borrowing";
const STRATEGY_TERM = "Advanced lending position";
const STRATEGY_TERM_PLURAL = "Advanced lending";
const MAX_DURATION_TOOLTIP = "The longest duration that borrowers can take out a loan for";
const ALLOWED_COLLATERAL_TOOLTIP = "The tokens you will accept as collateral. Loan-to-values are set by Loopscale";
const INTEREST_EARNED_LABEL = "Interest earned";
const MAX_DURATION_TERM = "Max duration";
const ALLOWED_COLLATERAL_TERM = "Eligible collateral";
const YIELD_SOURCE_TERM = "Idle capital";
const YIELD_SOURCE_LABEL = "Lend idle capital";
const YIELD_SOURCE_TOOLTIP =
    "Deposit idle capital into variable-rate lending while you wait for a loan to match to your position";
const EXTERNAL_YIELD_APY_TERM = "Current APY";
const EXTERNAL_YIELD_APY_TOOLTIP = "The APY you'll earn while waiting for loans";

const STRATEGY_APY_TOOLTIP = `Your ${STRATEGY_TERM.toLowerCase()} will only be used for loans when it's the lowest APY in the market`;
const STRATEGY_APY_TOOLTIP_LITE = "The APY you'll earn on new loans";
const PRINCIPAL_MARKETS_NET_BORROW_APY_TOOLTIP =
    "Shows the lowest available rate across all strategies with sufficient liquidity.";

const PRINCIPAL_MARKETS_NET_LEND_APY_TOOLTIP =
    "Shows the rate you can currently earn by lending across all strategies with available liquidity.";
const STRATEGY_APY_TERM = "Target APY";
const APY_TERM = "APY";

export const ORIGINATION_CAP = "Origination Cap";
export const ORIGINATION_CAP_STATUS = "Originations status";
export const ORIGINATION_CAP_TOOLTIP = "Restrict originations to this amount";

export const FINALIZED_TERM = "Finalized";
export const TYPE_TERM = "Type";
export const LTV_TERM = "LTV";

export const LIQUIDITY_BUFFER = "Liquidity buffer";
export const LIQUIDITY_BUFFER_TOOLTIP = "The reserve funds set aside to ensure liquidity for the loan.";

export const INTEREST_FEE = "Interest fee";
export const INTEREST_FEE_TOOLTIP = "The fee applied to the interest earned on this loan.";

export const ORIGINATION_FEE = "Origination fee";
export const ORIGINATION_FEE_TOOLTIP = "The fee charged for taking out a loan.";

export const MAX_ORIGINATION_SIZE = "Max origination size";
export const MAX_ORIGINATION_SIZE_TOOLTIP = "The maximum size of a loan allowed.";

export const OPTIONAL_LENDING_CONFIGURATION_TITLE = "Optional Lending Configurations";
export const OPTIONAL_LENDING_CONFIGURATION_TITLE_HELP_TEXT = "Optional values to customize your strategy.";

export const PRINCIPAL_FEE = "Principal Fee";

export const EXTERNAL_YIELD_SOURCE = "External Yield Source";

export const SLIPPAGE_TOOLTIP =
    "Higher slippage tolerance may improve transaction success rate, but may worsen execution price";

export const YIELD_SPREAD_TERM = "Term spread";

const ORIGINATED_ALL_TIME_TERM = "Volume (all time)";
export const PAST_DUE_WITHDRAW_TOOLTIP =
    "This loan is past due and cannot be withdrawn from. Please wait until the loan is refinanced or repaid.";
const strategy = {
    BORROW_TERM,
    BORROW_TERM_GERUND,
    STRATEGY_TERM,
    STRATEGY_TERM_PLURAL,
    MAX_DURATION_TOOLTIP,
    ALLOWED_COLLATERAL_TOOLTIP,
    MAX_DURATION_TERM,
    ALLOWED_COLLATERAL_TERM,
    INTEREST_EARNED_LABEL,
    YIELD_SOURCE_TERM,
    YIELD_SOURCE_LABEL,
    YIELD_SOURCE_TOOLTIP,
    STRATEGY_APY_TOOLTIP,
    STRATEGY_APY_TERM,
    STRATEGY_APY_TOOLTIP_LITE,
    PRINCIPAL_MARKETS_NET_BORROW_APY_TOOLTIP,
    PRINCIPAL_MARKETS_NET_LEND_APY_TOOLTIP,
    EXTERNAL_YIELD_APY_TERM,
    EXTERNAL_YIELD_APY_TOOLTIP,
    ORIGINATED_ALL_TIME_TERM,
    ORIGINATION_CAP,
    ORIGINATION_CAP_STATUS,
    COLLATERAL_TERM,
    FINALIZED_TERM,
    TYPE_TERM,
    LTV_TERM,
    ORIGINATION_CAP_TOOLTIP,
    LIQUIDITY_BUFFER,
    LIQUIDITY_BUFFER_TOOLTIP,
    INTEREST_FEE,
    INTEREST_FEE_TOOLTIP,
    ORIGINATION_FEE,
    ORIGINATION_FEE_TOOLTIP,
    MAX_ORIGINATION_SIZE,
    MAX_ORIGINATION_SIZE_TOOLTIP,
    OPTIONAL_LENDING_CONFIGURATION_TITLE,
    OPTIONAL_LENDING_CONFIGURATION_TITLE_HELP_TEXT,
    PRINCIPAL_FEE,
    EXTERNAL_YIELD_SOURCE,
    SLIPPAGE_TOOLTIP,
    APY_TERM,
    COLLATERAL_DEPOSITS_TERM,
    YIELD_SPREAD_TERM,
    PAST_DUE_WITHDRAW_TOOLTIP
};

const POINTS_TERM = "Points";
const POINTS_REASON_NO_STRATEGY = `No ${STRATEGY_TERM} data available`;
const POINTS_REASON_NO_ACTIVE_LOANS = "No active loans in this strategy";
const POINTS_REASON_PRINCIPAL_LENDING = "Principal asset has lending points multiplier";
const POINTS_REASON_PRINCIPAL_IDLE = "Principal asset has idle points multiplier";
const POINTS_REASON_COLLATERAL = "One or more active loan's collateral asset has a lending points multiplier";
const POINTS_REASON_NO_POINTS = `${STRATEGY_TERM} does not earn any points`;
const POINTS_REASON_EARNS_POINTS = `View active loans to see breakdown`;

const reasons = {
    POINTS_TERM,
    POINTS_REASON_NO_STRATEGY,
    POINTS_REASON_NO_ACTIVE_LOANS,
    POINTS_REASON_PRINCIPAL_LENDING,
    POINTS_REASON_PRINCIPAL_IDLE,
    POINTS_REASON_COLLATERAL,
    POINTS_REASON_NO_POINTS,
    POINTS_REASON_EARNS_POINTS
};
const ESCROW_TERM = "Escrow";
const ESCROW_TERM_ASSETS = "Escrowed assets";
const ESCROW_TERM_FULL = "Escrow account";

const escrow = { ESCROW_TERM, ESCROW_TERM_ASSETS, ESCROW_TERM_FULL };

const HEALTH_FACTOR_TERM = "Health";
const HEALTH_FACTOR_TOOLTIP =
    "This ratio represents how well-collateralized your loan is. Your collateral can be liquidated if your health is 0 or below";
const LIQUIDATION_THRESHOLD_TOOLTIP = "The loan-to-value where your collateral is exposed to being liquidated";
const LIQUIDATION_THRESHOLD_TERM = "Liquidation LTV";

const LIQUIDATION_PRICE_TERM = "Liquidation price";
const LIQUIDATION_PRICE_TERM_MOBILE = "Liq. price";
const LIQUIDATION_PRICE_TOOLTIP = "The price at which your collateral is exposed to being liquidated";

const INTEREST_EARNED_TO_DATE_TOOLTIP = "Interest earned to-date";
const MATURITY_TOOLTIP = "Auto-extends on this date unless originations are paused.";

const health = {
    HEALTH_FACTOR_TERM,
    HEALTH_FACTOR_TOOLTIP,
    LIQUIDATION_THRESHOLD_TERM,
    LIQUIDATION_PRICE_TERM,
    LIQUIDATION_PRICE_TERM_MOBILE,
    LIQUIDATION_THRESHOLD_TOOLTIP,
    LIQUIDATION_PRICE_TOOLTIP,
    INTEREST_EARNED_TO_DATE_TOOLTIP,
    MATURITY_TOOLTIP
};

//loop P&L
const LOOP_PNL_TERM = "Estimated P&L";
const LOOP_PNL_TERM_MOBILE = "Est. P&L";
const LOOP_PNL = "P&L";
const NET_INCOME_TERM = "Daily net interest";
const NET_INCOME_TOOLTIP = "Shows the daily profit or loss from interest earned minus interest owed";
const NET_INCOME_LENDER_TOOLTIP = "Shows the daily interest earned from this loan";

const loopPnl = {
    LOOP_PNL_TERM,
    LOOP_PNL_TERM_MOBILE,
    LOOP_PNL,
    NET_INCOME_TERM,
    NET_INCOME_TOOLTIP,
    NET_INCOME_LENDER_TOOLTIP
};
// info
const ASSET_INFO_TITLE = "Additional information";
const ASSET_ORIGINATOR_TITLE = "About loan custodian";
const ASSET_REDEMPTION_TITLE = "Recourse process";
const ASSET_ORDERS_TITLE = "Offers";
const ASSET_NOT_DEPOSITED_ALERT = "This asset must be deposited before offers can be sent";
const ASSET_PRICING_TOOLTIP = `Estimated value for an asset based on pricing data provided by the ${CUSTODIAN_TERM_FULL_PLURAL.toLocaleLowerCase()} (if available)`;
const ASSET_BRIDGE_TRANSFER_LENGTH = "Transfers typically take a few minutes";

const assetInfo = {
    ASSET_INFO_TITLE,
    ASSET_ORIGINATOR_TITLE,
    ASSET_REDEMPTION_TITLE,
    ASSET_ORDERS_TITLE,
    ASSET_NOT_DEPOSITED_ALERT,
    ASSET_PRICING_TOOLTIP,
    ASSET_BRIDGE_TRANSFER_LENGTH
};

// actions
const ASSET_ACTION_ACTIVE_LOAN = "Loan details";
const ASSET_ACTION_MAKE_REPAYMENT = "Make repayment";
const ASSET_ACTION_RECEIVING_OFFERS = "Receiving offers";
const ASSET_ACTION_DEFAULTED_LOAN = "Defaulted loan";
const ASSET_ACTION_PAID_OFF_LOAN = "Completed loan";
const ASSET_ACTION_LEDGER_OFFER = "Pending loan";

const assetActions = {
    ASSET_ACTION_ACTIVE_LOAN,
    ASSET_ACTION_MAKE_REPAYMENT,
    ASSET_ACTION_RECEIVING_OFFERS,
    ASSET_ACTION_DEFAULTED_LOAN,
    ASSET_ACTION_LEDGER_OFFER,
    ASSET_ACTION_PAID_OFF_LOAN
};

// tables
const WITHDRAW_ESCROW_CTA = "Withdraw";
const ASSET_PAGE_CTA = "View Asset";
const DEPOSIT_ESCROW_CTA = "Deposit assets";
const SEARCH_METADATA_PLACEHOLDER = "Search by asset";
const DEALS_EMPTY = "You don't have permission to view any deals";
const DEALS_EMPTY_FILTER = "No matching deals found";

const tableCtas = {
    DEALS_EMPTY,
    DEALS_EMPTY_FILTER,
    WITHDRAW_ESCROW_CTA,
    ASSET_PAGE_CTA,
    DEPOSIT_ESCROW_CTA,
    SEARCH_METADATA_PLACEHOLDER
};

const AUTH_INDIVIDUAL_GROUP_DESCRIPTION = "Personal account";
const WALLET_VERIFY = "You will need to pay a one time account fee of 0.00443 SOL to create your Loopscale Account";
const ACCOUNT_CREATE_PREVIEW = "By default, these account details will be shown on any loans you participate in";
const PASSKEY_SIGN_PROMPT = "Please authenticate with your device";
const WALLET_SIGN_PROMPT = "Please sign with your wallet";
const PASSKEY_SIGN_FAIL = "Unable to authenticate with your device";
const CONNECT_PROMPT = "Connect";

const auth = {
    AUTH_INDIVIDUAL_GROUP_DESCRIPTION,
    WALLET_VERIFY,
    ACCOUNT_CREATE_PREVIEW,
    PASSKEY_SIGN_PROMPT,
    WALLET_SIGN_PROMPT,
    PASSKEY_SIGN_FAIL,
    CONNECT_PROMPT
};

const REQUEST_DEFAULT = "Any";
const REQUEST_PREFERENCE_TOOLTIP = "The borrower has established this range as a preference for incoming offers";
const GRACE_PERIOD =
    "The amount of time after the payment that the borrower can repay without paying fees or defaulting";
const MATURITY_GRACE_PERIOD = "A window of time after the due date that the borrower can repay without defaulting";
const DUE_BY_TOOLTIP =
    "The time at which your loan is automatically refinanced into a new fixed-rate term, with accrued interest added to principal. We recommend reviewing the updated rate and overall loan health at the start of each term.";
const PREPAYMENT_GRACE_PERIOD =
    "Specify the min time remaining in the loan at which a borrower can repay a loan with prorated interest";

const LATE_FEE =
    "Following a missed payment beyond the grace period, an additional percentage will be added to the original amount due";

const PREPAYMENT =
    "Borrowers can benefit from reduced interest by repaying their loan in the early repayment window, paying the prorated interest plus a discounted rate on the unused portion of the loan term";
const PREPAYMENT_FEE_DESCRIPTION =
    "The percentage fee incurred for repaying principal before the maturity date. This fee is calculated based on the difference between the original interest due and the new interest due after early repayment. For instance, with a 50% fee, the borrower is required to pay 50% of the interest amount initially saved by repaying the loan ahead of schedule";

const request = {
    REQUEST_DEFAULT,
    REQUEST_PREFERENCE_TOOLTIP,
    PREPAYMENT_GRACE_PERIOD,
    GRACE_PERIOD,
    MATURITY_GRACE_PERIOD,
    LATE_FEE,
    PREPAYMENT,
    DUE_BY_TOOLTIP,
    PREPAYMENT_FEE_DESCRIPTION
};

const LOOP_TERM = "Loop";
const LOOP_TERM_ACTION = "Deposit";
const LOOP_TERM_PLURAL = "Loops";
const LEVERAGE_TERM = "Leverage";
const MAX_LEVERAGE_TERM = "Max leverage";
const DEPOSITED_TERM = "Deposited";
const LOOP_COLLATERAL_DEPOSIT_TERM = "Deposits";
const LOOP_PRINCIPAL_AVAILABLE_TERM = "Available";
const LOOP_ADDITIONAL_DEPOSITS_TERM = "Contributions";
const LOOP_ADDITIONAL_DEPOSITS_TOOLTIP = "Additional repayments and top ups after initial deposit";
const LOOP_ORACLE_DISCREPANCY_TERM = "Market premium";
const UNWIND_TERM = `Close ${LOOP_TERM}`;
const LOAN_NO_UNWIND_OPTIONS = `Automatic closing is currently unavailable due to low asset swap liquidity or Solana transaction size limits. Try increasing slippage or follow the steps below to close the ${LOOP_TERM.toLowerCase()} manually.`;
const MANAGE_LEVERAGE_TERM = "Manage Leverage";
const ROLLOVER_TERM = "Rollover";
const ORACLE_TERM_PLURAL = "Oracles";
const SAVE_SLIPPAGE = "Save slippage";
const SLIPPAGE_SETTINGS = "Slippage Settings";
const AVAILABLE_LIQUIDITY_TERM = "Available liquidity";
const AVAILABLE_LIQUIDITY_SHORT_TERM = "Liquidity";

const DEFAULT_ASSET_POOL_DISCLAIMER_TEXT = "Functionality for Loops and Loans can be limited due to the asset pool.";

const MARKET_HOURS_DISCLAIMER_LINK = "https://docs.loopscale.com/using-loopscale/loop#market-hours";
const LOOP_ROLLOVER_TERM = "Rollover";
const LOOP_ROLLOVER_DESCRIPTION =
    "Roll into a PT-token with a future expiry to continue your position without unwinding or execution costs.";
const LOOP_REDEEM_DESCRIPTION =
    "Redeem your matured PT for the underlying asset and keep the position open, earning its variable yield.";
const LOOP_ROLLOVER_WITHDRAW_TOOLTIP = "Projected collateral amount if position is held to token maturity";
const LOOP_ROLLOVER_BORROW_APY_TOOLTIP = "Reflects any difference in borrow APY for new collateral";
const LOOP_ROLLOVER_NET_APY_TOOLTIP =
    "Reflects any differences in borrow APY and collateral base APY for new collateral";
const LOOP_ROLLOVER_HEALTH_TOOLTIP = "Changes to health may be due to the value or assigned LTV for new collateral";
const LOOP_ROLLOVER_WARNING_MESSAGE =
    "The new collateral asset is not supported by the current lender for your position. Try again later.";

const loop = {
    LOOP_TERM,
    LOOP_TERM_PLURAL,
    LEVERAGE_TERM,
    MAX_LEVERAGE_TERM,
    LOOP_COLLATERAL_DEPOSIT_TERM,
    LOOP_PRINCIPAL_AVAILABLE_TERM,
    LOOP_TERM_ACTION,
    LOOP_ADDITIONAL_DEPOSITS_TERM,
    LOOP_ADDITIONAL_DEPOSITS_TOOLTIP,
    LOOP_ORACLE_DISCREPANCY_TERM,
    UNWIND_TERM,
    LOAN_NO_UNWIND_OPTIONS,
    LOOP_ROLLOVER_TERM,
    LOOP_ROLLOVER_DESCRIPTION,
    LOOP_REDEEM_DESCRIPTION,
    LOOP_ROLLOVER_WITHDRAW_TOOLTIP,
    LOOP_ROLLOVER_BORROW_APY_TOOLTIP,
    LOOP_ROLLOVER_NET_APY_TOOLTIP,
    LOOP_ROLLOVER_HEALTH_TOOLTIP,
    LOOP_ROLLOVER_WARNING_MESSAGE,
    MARKET_HOURS_DISCLAIMER_LINK,
    DEFAULT_ASSET_POOL_DISCLAIMER_TEXT,
    ORACLE_TERM_PLURAL,
    SAVE_SLIPPAGE,
    SLIPPAGE_SETTINGS,
    AVAILABLE_LIQUIDITY_TERM,
    AVAILABLE_LIQUIDITY_SHORT_TERM,
    DEPOSITED_TERM,
    ROLLOVER_TERM,
    MANAGE_LEVERAGE_TERM
};

const VAULT_WITHDRAW_SETTINGS = "Vault Withdraw Setting";
const VAULT_DEPOSIT_CTA = "Deposit";
const FEATURED_VAULT_SUPPLY_DETAILS = "Featured Vaults have phased supply limits";
const SUPPLY_LIMIT_REACHED = "Supply limit reached";
const VAULT_ACCESS_RESTRICTED = "Wallet not approved for this vault";
const VAULT_WITHDRAW_CTA = "Withdraw";
const VAULT_MANAGER_TIMELOCK_INIT_CTA = "Save changes";
const VAULT_MANAGER_TERM = "Curator";
const VAULT_MANAGER_PREFIX = "Curated by";
const VAULT_TERM = "Vault";
const VAULT_TERM_PLURAL = "Vaults";
const VAULT_TERM_PLURAL_FEATURED = "Featured Vaults";
const EARN_TERM = "Earn";
const EARN_TERM_DESCRIPTION =
    "One-click deposits to earn yield across lending, looping, and fixed-yield strategies curated by Loopscale.";
const EARN_TERM_PLURAL_FEATURED = "Featured Earn Vaults";
const VAULT_TERM_FEATURED = "Featured Vault";
const ALL_LOOPSCALE_VAULTS = "Explore Loopscale Vaults";
const NO_LIMITS = "No limits";
const SUPPLIED_TERM = "Supplied";
const SUPPLY_TERM = "Supply";
const LIMIT_TERM = "Limit";

const TVL_TERM = "Lend TVL";
const EARN_TVL_TERM = "Vault TVL";
const CURRENT_DEPLOYED_AMOUNT_TERM = "Deployed";
const USER_POSITION_TERM = "Position value";
const LIQUIDITY_BUFFER_TERM = "Liquidity buffer";
const LIQUIDITY_BUFFER_TERM_TOOLTIP =
    "The minimum liquidity required for instant withdrawals. No lending offers will be placed if idle liquidity is below the buffer";
const REMAINING_TERM = "Remaining";
const EARN_UTILIZATION_TERM = "Deployed";
const EARN_APY_TERM = "APY";
const EARN_REALIZED_RETURN_TERM = "Realized return";
const EARN_REALIZED_RETURN_TOOLTIP =
    "Backward-looking NAV-delta return over the trailing window. Distinct from APY, which is the forward-looking share-weighted composite of each underlying allocation's APY.";
const EARN_DEPOSIT_ASSET_TERM = "Deposit asset";
const EARN_SHARE_PRICE_TERM = "Share price";
const NO_ACTIVE_POSITION_IN_VAULT = "No active position in this vault";

const vault = {
    VAULT_WITHDRAW_SETTINGS,
    VAULT_DEPOSIT_CTA,
    FEATURED_VAULT_SUPPLY_DETAILS,
    SUPPLY_LIMIT_REACHED,
    VAULT_ACCESS_RESTRICTED,
    VAULT_WITHDRAW_CTA,
    VAULT_MANAGER_TIMELOCK_INIT_CTA,
    VAULT_MANAGER_TERM,
    VAULT_MANAGER_PREFIX,
    VAULT_TERM,
    VAULT_TERM_PLURAL,
    VAULT_TERM_PLURAL_FEATURED,
    VAULT_TERM_FEATURED,
    ALL_LOOPSCALE_VAULTS,
    SUPPLIED_TERM,
    SUPPLY_TERM,
    LIMIT_TERM,
    TVL_TERM,
    EARN_TVL_TERM,
    CURRENT_DEPLOYED_AMOUNT_TERM,
    REMAINING_TERM,
    USER_POSITION_TERM,
    LIQUIDITY_BUFFER_TERM,
    LIQUIDITY_BUFFER_TERM_TOOLTIP,
    NO_LIMITS,
    EARN_TERM,
    EARN_TERM_DESCRIPTION,
    EARN_TERM_PLURAL_FEATURED,
    EARN_SHARE_PRICE_TERM,
    EARN_UTILIZATION_TERM,
    EARN_APY_TERM,
    EARN_REALIZED_RETURN_TERM,
    EARN_REALIZED_RETURN_TOOLTIP,
    EARN_DEPOSIT_ASSET_TERM,
    NO_ACTIVE_POSITION_IN_VAULT
};

const TRANSACTION_FEE = "Fees";
const TRANSACTION_FEE_TOTAL = "Total Fees";
const TRANSACTION_FEE_NET = "Net Fees";
const SETUP_FEE = "Setup (one time)";
const RENT_REFUNDABLE = "Rent (refundable)";
const RENT_NON_REFUNDABLE = "Rent (non-refundable)";
const RENT_NETWORK = "Network";
const RENT_ESTIMATE_TOOLTIP = "The USD estimate is the total non-refundable fee to fill the transaction";
const RENT_EXTERNAL_YIELD = "Idle Capital Rent (refundable)";

const TRANSACTION_SETTINGS_TITLE = "Transaction Settings";
const TRANSACTION_MAX_FEE = "Max Fee";
const TRANSACTION_MAX_FEE_TOOLTIP = "Optional, set your max fee to prevent paying more than a certain amount";
const TRANSACTION_EXACT_FEE = "Exact Fee";
const TRANSACTION_EXACT_FEE_TOOLTIP = "Optional, overrides max fee and fee level";
const TRANSACTION_FEE_LEVEL = "Fee Level";
const TRANSACTION_FEE_LEVEL_TOOLTIP =
    "Set your fee level, the higher you set it, the more likely it is to land quickly. However, when the chain is congested you may end up paying a higher fee.";
const TRANSACTION_BROADCAST_MODE = "Broadcast Type";
const TRANSACTION_BROADCAST_MODE_TOOLTIP = "Send with priority fees, Jito, or both (defaults to Priority Fee)";

const transactions = {
    TRANSACTION_FEE,
    TRANSACTION_FEE_TOTAL,
    TRANSACTION_FEE_NET,
    SETUP_FEE,
    RENT_REFUNDABLE,
    RENT_NON_REFUNDABLE,
    RENT_NETWORK,
    RENT_ESTIMATE_TOOLTIP,
    TRANSACTION_SETTINGS_TITLE,
    TRANSACTION_MAX_FEE,
    TRANSACTION_MAX_FEE_TOOLTIP,
    TRANSACTION_EXACT_FEE,
    TRANSACTION_EXACT_FEE_TOOLTIP,
    TRANSACTION_FEE_LEVEL,
    TRANSACTION_FEE_LEVEL_TOOLTIP,
    TRANSACTION_BROADCAST_MODE,
    TRANSACTION_BROADCAST_MODE_TOOLTIP,
    RENT_EXTERNAL_YIELD
};

const REWARDS_SUFFIX = " rewards";
const EARN_REWARDS = LOOP_TERM + REWARDS_SUFFIX;
const RATES_AND_REWARDS = "Rates and" + REWARDS_SUFFIX;
const BORROW_REWARDS = "Borrow" + REWARDS_SUFFIX;
const LEND_REWARDS = "Lend" + REWARDS_SUFFIX;

const rewards = {
    EARN_REWARDS,
    RATES_AND_REWARDS,
    BORROW_REWARDS,
    LEND_REWARDS
};

const LEND_VAULTS_TERM = "Lend vault";
const LEND_VAULTS_TERM_PLURAL = "Lend vaults";
const LEND_VAULTS_PRODUCT_TERM = "Loopscale Vaults";
const LEND_VAULTS_PRODUCT_TERM_PLURAL = "Loopscale Vaults";
const LEND_VAULTS_TIME_LOCK_TOOLTIP = "Preview using latest time locks (if any)";
const NET_DEPOSITS = "Net Deposits";
const MARKET_SIZE_TERM = "Market size";

const lendVaults = {
    LEND_VAULTS_TERM,
    LEND_VAULTS_TERM_PLURAL,
    LEND_VAULTS_PRODUCT_TERM,
    LEND_VAULTS_PRODUCT_TERM_PLURAL,
    LEND_VAULTS_TIME_LOCK_TOOLTIP,
    NET_DEPOSITS,
    MARKET_SIZE_TERM
};

const DAILY_REWARDS_TERM = "Daily rewards";
const DAILY_INTEREST_TERM = "Daily interest";
const TOTAL_COLLATERAL_TERM = "Total collateral";
const TOTAL_BORROWED_TERM = "Total borrowed";
const TOTAL_SUPPLIED_TERM = "Total supplied";
const TOTAL_INTEREST_EARNED_TERM = "Total interest earned";
const NET_VALUE_TERM = "Net value";
const NET_POSITION_TERM = "Net position";
const NET_APY_TERM = "Net APY";
const NET_APY_TOOLTIP = "Annualized return on equity: (collateral yield − debt interest) × 365 / net position";
const AVG_APY_TERM = "Avg. APY";
const AVG_APY_TOOLTIP = "Weighted average APY of all active loans based on USD loan size";
const PENDING_YIELD_TERM = "Pending yield";
const PORTFOLIO_DAILY_INTEREST_TOOLTIP =
    "Total daily interest across all positions: lend + vault earnings + collateral income minus borrow + loop costs";
const SECTION_DAILY_INTEREST_TOOLTIP =
    "Total daily interest across all positions: collateral income minus borrow interest";

const portfolioStats = {
    DAILY_REWARDS_TERM,
    DAILY_INTEREST_TERM,
    TOTAL_COLLATERAL_TERM,
    TOTAL_BORROWED_TERM,
    TOTAL_SUPPLIED_TERM,
    TOTAL_INTEREST_EARNED_TERM,
    NET_VALUE_TERM,
    NET_POSITION_TERM,
    NET_APY_TERM,
    NET_APY_TOOLTIP,
    AVG_APY_TERM,
    AVG_APY_TOOLTIP,
    PENDING_YIELD_TERM,
    PORTFOLIO_DAILY_INTEREST_TOOLTIP,
    SECTION_DAILY_INTEREST_TOOLTIP
};

const ECOSYSTEM_TERM = "Ecosystem";
const ECOSYSTEM_STATS_INTEGRATIONS_TERM = "Protocols";

const ecosystem = {
    ECOSYSTEM_TERM,
    ECOSYSTEM_STATS_INTEGRATIONS_TERM
};

const SEEKER_GENESIS_TOKEN_TERM = "Seeker Genesis Token";
const community = {
    SEEKER_GENESIS_TOKEN_TERM
};

const PRINCIPAL_CAPS_BORROW_TERM = "Borrow";
const PRINCIPAL_CAPS_SUPPLY_TERM = "Supply";
const PRINCIPAL_CAPS_WITHDRAW_TERM = "Withdraw";

const PRINCIPAL_CAPS_MAX_1HR_BORROW_TERM = "Max 1hr borrow";
const PRINCIPAL_CAPS_MAX_24HR_BORROW_TERM = "Max 24hr borrow";
const PRINCIPAL_CAPS_MAX_OUTSTANDING_BORROW_TERM = "Max borrow";
const PRINCIPAL_CAPS_MAX_1HR_SUPPLY_TERM = "Max 1hr supply";
const PRINCIPAL_CAPS_MAX_24HR_SUPPLY_TERM = "Max 24hr supply";
const PRINCIPAL_CAPS_MAX_OUTSTANDING_SUPPLY_TERM = "Max TVL";
const PRINCIPAL_CAPS_MAX_1HR_WITHDRAW_TERM = "Max 1hr withdrawals";
const PRINCIPAL_CAPS_MAX_24HR_WITHDRAW_TERM = "Max 24hr withdrawals";

const principalCaps = {
    PRINCIPAL_CAPS_BORROW_TERM,
    PRINCIPAL_CAPS_SUPPLY_TERM,
    PRINCIPAL_CAPS_WITHDRAW_TERM,
    PRINCIPAL_CAPS_MAX_1HR_BORROW_TERM,
    PRINCIPAL_CAPS_MAX_24HR_BORROW_TERM,
    PRINCIPAL_CAPS_MAX_OUTSTANDING_BORROW_TERM,
    PRINCIPAL_CAPS_MAX_1HR_SUPPLY_TERM,
    PRINCIPAL_CAPS_MAX_24HR_SUPPLY_TERM,
    PRINCIPAL_CAPS_MAX_OUTSTANDING_SUPPLY_TERM,
    PRINCIPAL_CAPS_MAX_1HR_WITHDRAW_TERM,
    PRINCIPAL_CAPS_MAX_24HR_WITHDRAW_TERM
};

const REPAY_TERM = "Repay";
const REFINANCE_TERM = "Adjust terms";
const BORROW_MORE_TERM = "Borrow more";
const TOP_UP_COLLATERAL_TERM = "Add collateral";
const WITHDRAW_COLLATERAL_TERM = "Withdraw collateral";
const MANAGE_POSITION_TERM = "Manage position";
const MANAGE_LEVERAGE_TERM_ACTION = "Manage leverage";
const CLOSE_LOAN_TERM = "Close loan";

const loanActions = {
    REPAY_TERM,
    REFINANCE_TERM,
    BORROW_MORE_TERM,
    TOP_UP_COLLATERAL_TERM,
    WITHDRAW_COLLATERAL_TERM,
    MANAGE_POSITION_TERM,
    MANAGE_LEVERAGE_TERM_ACTION,
    CLOSE_LOAN_TERM
};

const YOUR_POSITION_TERM = "Your position";
const POSITION_SHARES_TERM = "Shares";
const POSITION_AVG_COST_BASIS_TERM = "Avg. cost basis/share";
const POSITION_COST_BASIS_TERM = "Total cost basis";
const POSITION_UNREALIZED_PNL_TERM = "Unrealized P&L";
const POSITION_REALIZED_PNL_TERM = "Realized P&L (lifetime)";
const POSITION_FEES_PAID_TERM = "Fees paid (lifetime)";
const OPEN_WITHDRAWAL_REQUESTS_TERM = "Your open withdrawal requests";

const earnPosition = {
    YOUR_POSITION_TERM,
    POSITION_SHARES_TERM,
    POSITION_AVG_COST_BASIS_TERM,
    POSITION_COST_BASIS_TERM,
    POSITION_UNREALIZED_PNL_TERM,
    POSITION_REALIZED_PNL_TERM,
    POSITION_FEES_PAID_TERM,
    OPEN_WITHDRAWAL_REQUESTS_TERM
};

export const COPY = {
    ...custodian,
    ...assetInfo,
    ...assetActions,
    ...tableCtas,
    ...auth,
    ...request,
    ...escrow,
    ...health,
    ...strategy,
    ...loop,
    ...loopPnl,
    ...transactions,
    ...rewards,
    ...reasons,
    ...vault,
    ...lendVaults,
    ...portfolioStats,
    ...ecosystem,
    ...community,
    ...principalCaps,
    ...loanActions,
    ...earnPosition
};

export enum AppTab {
    Assets = "assets",
    Offers = "offers",
    Loans = "loans",
    Payments = "payments",
    Activity = "activity",
    GeneralSettings = "general"
}
